import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Input } from '../../../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../../../services/LinePickingService';
import { onValueChange, validateInputsRequired } from '../../../../../../utils/handleChangeHooks';
import { translate } from '../../../../../../utils/util';
import ModalUpload from './ModalUpload';

const QrCodeCallInsert = (props) => {
    const [qrCodeCall, setqrCodeCall] = useState(props.location?.state?.update && props.qrCodeCall ? props.qrCodeCall : {});
    const update = props.location?.state?.update;
    const [openModal, setOpenModal] = useState(false)

    const subtitles = () => {
        return [{ icon: "mdi mdi-plus-box-outline", label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }];
    }

    const onChange = (event) => {
        onValueChange(event, qrCodeCall, setqrCodeCall);
    };

    const redirect = () => {
        props.history.goBack();
    }

    const onConfirm = () => {
        if (validateInputsRequired("formQrCodeCallInsert")) {
            props.add(qrCodeCall, () => {
                redirect();
            });
        }
    };

    return (
        <div>
            <Breadcrumbs id="qrCodeInsert" title={{ icon: "mdi mdi-qrcode", label: translate('picking.qrCodeCall', 'expedition') }} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formQrCodeCallInsert" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        required
                                        label={translate('picking.partnumber', 'expedition')}
                                        id="partNumber"
                                        name="partNumber"
                                        type="text"
                                        defaultValue={qrCodeCall?.partNumber} />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        onChange={onChange}
                                        required
                                        label={translate('fields.pdu', 'delivery')}
                                        id="pdu"
                                        name="pdu"
                                        type="text"
                                        defaultValue={qrCodeCall?.pdu} />
                                </div>
                            </div>
                            <div className="input-field no-padding  col s1">
                                <button
                                    className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={() => setOpenModal(true)}>
                                    <i className="Small material-icons">cloud_upload</i>
                                </button>
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalUpload
                open={openModal}
                id="ModalUpload"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        add: (qrCodeCall, callback) => {
            dispatch(LinePickingService.addPartNumberPdu(qrCodeCall, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(QrCodeCallInsert)));
